import { useState, useEffect } from "react";
import ImageThumbnail from "/componentry/Jobs/Thumbnails/Image";
import TextThumbnail from "/componentry/Jobs/Thumbnails/Text";
import LoadingThumbnail from "/componentry/Jobs/LoadingThumbnail";
import InfiniteScroll from "react-infinite-scroll-component";
import { bookshelf, server } from "/lib/publicEnv";
import { FaArrowLeft, FaFilter, FaStar } from "react-icons/fa";
import { categoryColours } from "/lib/workCategories";
import qs from "qs";

import { useRouter } from "next/router";
import CategoryDropdown from "/componentry/Jobs/Sorts/Categories";
import FeedSort, { currents } from "/componentry/Jobs/Sorts/Feed";
import Image from "next/image";

const filterDefaults = {
    category: null,
    position: null,
    sort: "createdAt:desc"
};

export default function Videos() {
    const router = useRouter();
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [positions, setPositions] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [more, setMore] = useState(true);
    const [ filterMeta, setFilterMeta ] = useState({
        categoryList: []
    });
    const [filters, setFilters] = useState(filterDefaults);
    const [positionTypeLoading, setPositionTypeLoading] = useState(false);

    const filtersChanged = filters?.category !== filterDefaults?.category || filters?.position !== filterDefaults?.position || filters?.sort !== filterDefaults?.sort || filters?.open !== filterDefaults?.open;

    const qp = qs.stringify({
        start: Math.ceil(positions.length / 40),
        limit: 40,
        category: filters?.category,
        open: true,
    }, { encodeValuesOnly: true });

    async function fetchJobs(initial) {
        if (initial && positions.length !== 0) return;
        const res = await fetch(`${server}/api/jobs/fetchAll?${qp}`).then(res => res.json()).catch(err => console.log(err));
        let posArr = res.data?.positions;
        if ((res.data?.pagination?.total <= positions.length) || (res.data?.pagination?.total <= res.data?.positions?.length)) setMore(false);
        
        let shownPositions = [];
        setPositions((p) => [...p, ...posArr].filter((p) => {
            if (shownPositions.includes(p.id)) return false;
            shownPositions.push(p.id);
            return true;
        }));
    };

    useEffect(() => {
        async function fetchInitialJobs(initial, vtl) {
            if (initial && positions.length !== 0) return;
            if (vtl) {
                setPositionTypeLoading(true);
                setLoaded(false);
            };

            const res = await fetch(`${server}/api/jobs/fetchAll?${qp}`).then(res => res.json()).catch(err => console.log(err));
            let posArr = res.data?.positions;
            if ((res.data?.pagination?.total <= positions.length) || (res.data?.pagination?.total <= res.data?.positions?.length)) setMore(false);
            
            let shownPositions = [];
            setPositions((p) => [...p, ...posArr].filter((p) => {
                if (shownPositions.includes(p.id)) return false;
                shownPositions.push(p.id);
                return true;
            }));

            setFilterMeta({
                ...filterMeta,
                categoryList: res.data?.categories?.map(c => c.displayName).filter((v, i, a) => a.indexOf(v) === i)
            });

            if (vtl) {
                setPositionTypeLoading(false);
                setLoaded(true);
            };

            if (initial && !vtl) setLoaded(true);
        };

        if (router.isReady && !loaded && !positionTypeLoading) {
            fetchInitialJobs(true);
        };

        if (loaded && positionTypeLoading) {
            setPositions([]);
            fetchInitialJobs(true, true);
        };
    }, [router.isReady, positions.length, loaded, positionTypeLoading]);

    return (
        <main className="flex flex-col gap-y-4 px-12 py-4 pt-8 md:py-12 text-white font-BreezeHeader font-bold sm:items-start min-h-screen">
            <div className="flex flex-col gap-y-4 items-start sm:items-start w-full">
                <div className="flex flex-col px-4 gap-y-4">
                    {
                        (filtersChanged) && (
                            <button 
                                className="w-fit md:hidden flex flex-row gap-x-2 mb-0 md:mb-0 text-xs leading-tight px-4 py-2 items-center bg-cyan-200 hover:bg-cyan-300 active:shadow-lg transition duration-150 ease-in-out uppercase text-sp text-black rounded-full"
                                onClick={(() => {
                                    setFilters(defaultFilters);
                                    setUserMeta(userMetaDefault);
                                    setVideoType("unsorted");
                                    setVideoTypeLoading(true);
                                })}
                            >
                                <FaArrowLeft />
                                Back
                            </button>
                        )
                    }
                    <h1 className="flex flex-row gap-x-4 items-center text-2xl font-BreezeAltHeader">
                        {
                            (filtersChanged) && (
                                <button 
                                    className="w-fit hidden md:flex flex-row gap-x-2 mb-4 md:mb-0 text-xs leading-tight px-4 py-2 items-center bg-cyan-200 hover:bg-cyan-300 active:shadow-lg transition duration-150 ease-in-out uppercase text-sp text-black rounded-full"
                                    onClick={(() => {
                                        setFilters(filterDefaults);
                                        setPositionTypeLoading(true);
                                    })}
                                >
                                    <FaArrowLeft />
                                    Back
                                </button>
                            )
                        }
                        {
                            (filtersChanged) ? 
                            `Open ${filters.category !== null ? " " + filters.category.toLowerCase() : ""} positions ${filters.sort !== "createdAt:desc" ? "(sorted by " + currents.find(c => c.key === filters.sort)?.short + ")" : ""}`
                                : 
                            `Open positions`
                        }
                        <button onClick={(() => setFiltersOpen(!filtersOpen))} className="md:hidden">
                            <FaFilter className="text-xl hover:text-gray-300 transition duration-150 ease-in-out" />
                        </button>
                    </h1>
                </div>
                <div className={`${filtersOpen ? "block" : "hidden md:block"} pt-2 md:pt-0 rounded-xl w-full`}>
                    <div className="grid grid-cols-2 sm:flex sm:flex-row gap-x-0 gap-y-4 sm:gap-x-4 px-4 items-center justify-center sm:justify-start">
                        <FeedSort current={filters?.sort} onClick={(o) => {
                            setFilters({
                                ...filters,
                                sort: o,
                            });
                            setPositionTypeLoading(true);
                        }} />
                        <CategoryDropdown current={filters?.category} categories={filterMeta?.categoryList} onClick={(o) => {
                            setFilters({
                                ...filters,
                                category: o,
                            });
                            setPositionTypeLoading(true);
                        }} />
                    </div>
                </div>
            </div>
            <div className="w-full">
                {(() => {
                    if (!loaded) {
                        const k = [...Array(50).keys()];
                        return (
                            <>
                                <div 
                                    className={`grid md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 3xl:grid-cols-4 gap-x-3 2xl:gap-x-4 gap-y-8 overflow-x-hidden no-scrollbar py-2 pt-4 px-4`}
                                >
                                    {
                                        (k).map((i) => (
                                            <LoadingThumbnail key={i} />
                                        ))
                                    }
                                </div>
                            </>
                        );
                    } else {
                        const k = [...Array(15).keys()];
                        return (
                            <>
                                <InfiniteScroll 
                                    className={`grid md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 3xl:grid-cols-4 gap-x-3 2xl:gap-x-4 gap-y-8 overflow-x-hidden no-scrollbar py-2 pt-4 px-4`}
                                    dataLength={positions.length}
                                    next={fetchJobs}
                                    hasMore={more}
                                    loader={(k).map((i) => (
                                        <LoadingThumbnail key={i} />
                                    ))}
                                >
                                    {
                                        positions.map((position, index) => { 
                                            const catColourData = categoryColours[position?.category?.colour] || undefined;
                                            if (position === null) return;
                                            return (
                                                <div key={index}>
                                                    <TextThumbnail closed={position?.open} icon={position.category?.icon && `${position.category?.icon}`} catData={catColourData} id={position?.id} begins={position?.positionBegins} pay={position?.pay} location={position?.location} tagline={position?.subtitle} cadence={position?.cadence || "Freelance"} title={position?.title} thumb={position.banner?.data?.attributes?.url ? `${bookshelf}${position.banner?.data?.attributes?.url}` : "/unloaded.png"} optimized />
                                                </div>
                                            )
                                        })
                                    }
                                </InfiniteScroll>
                            </>
                        );
                    };
                })()}
                {
                    ((positions.length === 0)) && (
                        <div className="flex flex-col justify-center items-center w-full py-8 gap-y-4">
                            <Image width="96" height="96" referrerPolicy="no-referrer" className="w-32 h-32" alt={"Cookie Munch"} src={"/cookieEat.gif"} />
                            <p className="text-center text-lg text-gray-400">
                                <b>There&apos;s nothing here?</b>
                            </p>
                        </div>
                    )
                }
                {
                    ((positions.length !== 0) && !more) && (
                        <div className="flex flex-col justify-center items-center w-full py-8 gap-y-4">
                            <Image width="96" height="96" referrerPolicy="no-referrer" className="w-32 h-32" alt={"Cookie Munch"} src={"/cookieEat.gif"} />
                            <p className="text-center text-lg text-gray-400">
                                <b>Yay! You&apos;ve seen it all.</b>
                            </p>
                        </div>
                    )
                }
            </div>
        </main>
    );
};
